import { DialogRefundConfirmComponent } from './components/dialog-refund-confirm/dialog-refund-confirm.component';
import { LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { LoginComponent } from './components/login/login.component';
import { AngularMaterialModule } from './material.module';
import { NgxAwesomePopupModule, DialogConfigModule, ConfirmBoxConfigModule, ToastNotificationConfigModule } from '@costlydeveloper/ngx-awesome-popup';

/**
 * JWT
 */
import { JwtInterceptor } from './helpers/jwt.interceptor';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { EventCardComponent } from './components/event-card/event-card.component';
import { CardsWrapperComponent } from './components/cards-wrapper/cards-wrapper.component';
import { ProductsResumeComponent } from './components/products-resume/products-resume.component';
import { ResumeEventCardComponent } from './components/resume-event-card/resume-event-card.component';
import { EventComponent } from './components/event/event.component';
import { CalendarComponent } from './components/calendar/calendar.component';
import { EventTicketsComponent } from './components/event-tickets/event-tickets.component';
import { DateAdapter, MAT_DATE_LOCALE } from '@angular/material/core';
import { CustomDateAdapter } from './custom-date-adapter';
import localeEs from '@angular/common/locales/es';
import { DatePipe, registerLocaleData } from '@angular/common';
import localeEn from '@angular/common/locales/en';
import { SelectCashRegisterComponent } from './components/select-cash-register/select-cash-register.component';
import { DialogStartCashRegisterComponent } from './components/dialog-start-cash-register/dialog-start-cash-register.component';
import { DialogSelectPaymentComponent } from './components/dialog-select-payment/dialog-select-payment.component';
import { DialogPayComponent } from './components/dialog-pay/dialog-pay.component';
import { CashRegisterReportComponent } from './components/cash-register-report/cash-register-report.component';
import { CashRegisterReportDetailComponent } from './components/cash-register-report-detail/cash-register-report-detail.component';
import { NgxSpinnerModule } from 'ngx-spinner';
import { SeatMapComponent } from './components/seat-map/seat-map.component';
import { DialogPaymentConfirmComponent } from './components/dialog-payment-confirm/dialog-payment-confirm.component';
import { DialogCleanCartComponent } from './components/dialog-clean-cart/dialog-clean-cart.component';
import { DialogPromoCodeComponent } from './components/dialog-promo-code/dialog-promo-code.component';
import { DialogUnlockSeatsComponent } from './components/dialog-unlock-seats/dialog-unlock-seats.component';
import { DialogDeletePassComponent } from './components/dialog-delete-pass/dialog-delete-pass.component';
import { DialogErrorBondsComponent } from './components/dialog-error-bonds/dialog-error-bonds.component';
import { EventsComponent } from './pages/events/events.component';
import { StatusBarComponent } from './components/status-bar/status-bar.component';
import { EventSaleComponent } from './pages/event-sale/event-sale.component';
import { EventsResumeComponent } from './components/events-resume/events-resume.component';
import { EventsHorizontalCardComponent } from './components/events-horizontal-card/events-horizontal-card.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { RefundsComponent } from './pages/refunds/refunds.component';
import { RefundDetailComponent } from './pages/refund-detail/refund-detail.component';
import { DialogRefundOrderComponent } from './components/dialog-refund-order/dialog-refund-order.component';
import { DialogFeedbackComponent } from './components/dialog-feedback/dialog-feedback.component';
import { DialogPartialRefundConfirmComponent } from './components/dialog-partial-refund-confirm/dialog-partial-refund-confirm.component';
import { DialogGenericComponent } from './components/dialog-generic/dialog-generic.component';
import { ReservasListComponent } from './pages/reservas/reservas-list.component';
import { ReservaDetailComponent } from './pages/reservas/reserva-detail.component';
import { DialogReservationPayComponent } from './components/dialog-reservation-pay/dialog-reservation-pay.component';
import { ReservationResumeComponent } from './components/reservation-resume/reservation-resume.component';
import { DialogSettingsComponent } from './components/dialog-settings/dialog-settings.component';
import { DialogSaveReservationComponent } from './components/dialog-save-reservation/dialog-save-reservation.component';
import { PassesComponent } from './pages/passes/passes.component';
import { PassSaleComponent } from './pages/pass-sale/pass-sale.component';
import { PassSaleBulkComponent } from './pages/pass-sale-bulk/pass-sale-bulk.component';
import { PassCardComponent } from './components/pass-card/pass-card.component';
registerLocaleData(localeEs, 'es');
registerLocaleData(localeEn);

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    EventCardComponent,
    CardsWrapperComponent,
    ProductsResumeComponent,
    ResumeEventCardComponent,
    EventComponent,
    EventTicketsComponent,
    SelectCashRegisterComponent,
    DialogStartCashRegisterComponent,
    DialogSelectPaymentComponent,
    DialogPayComponent,
    CashRegisterReportComponent,
    CashRegisterReportDetailComponent,
    SeatMapComponent,
    DialogPaymentConfirmComponent,
    DialogCleanCartComponent,
    DialogDeletePassComponent,
    DialogErrorBondsComponent,
    EventsComponent,
    StatusBarComponent,
    EventSaleComponent,
    EventsResumeComponent,
    EventsHorizontalCardComponent,
    RefundsComponent,
    RefundDetailComponent,
    DialogRefundOrderComponent,
    DialogRefundConfirmComponent,
    DialogPartialRefundConfirmComponent,
    DialogFeedbackComponent,
    DialogGenericComponent,
    ReservasListComponent,
    ReservaDetailComponent,
    DialogReservationPayComponent,
    ReservationResumeComponent,
    DialogSettingsComponent,
    DialogPromoCodeComponent,
    DialogUnlockSeatsComponent,
    DialogSaveReservationComponent,
    PassesComponent,
    PassSaleComponent,
    PassSaleBulkComponent,
    PassCardComponent

  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    AngularMaterialModule,
    HttpClientModule,
    NgxAwesomePopupModule.forRoot(), // Essential, mandatory main module.
    DialogConfigModule.forRoot(), // Needed for instantiating dynamic components.
    ConfirmBoxConfigModule.forRoot(), // Needed for instantiating confirm boxes.
    ToastNotificationConfigModule.forRoot(),
    NgxSpinnerModule.forRoot({ type: 'ball-scale-multiple' }),
    FontAwesomeModule,
    CalendarComponent,
    MatProgressSpinnerModule,

  ],
  providers: [
    DatePipe,
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: LOCALE_ID, useValue: 'es-ES' },
    { provide: MAT_DATE_LOCALE, useValue: 'es-ES' },
    { provide: DateAdapter, useClass: CustomDateAdapter },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
